import type { SyncQueueItem } from './syncTypes';

export function splitSyncQueueByUser(queue: SyncQueueItem[], userId: string) {
  return {
    currentUserQueue: queue.filter(item => item?.userId === userId),
    retainedQueue: queue.filter(item => item?.userId !== userId)
  };
}